import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export default function AssignDevicesPage() {
  const { company_id } = useParams();
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchUnassignedDevices = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/superadmin/devices/unassigned`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!res.ok) throw new Error('Failed to fetch unassigned devices');
      const data = await res.json();
      setDevices(data.devices || []);
    } catch (err) {
      console.error(err);
      alert('Failed to load devices');
    } finally {
      setLoading(false);
    }
  };

  const handleAssign = async (device_id) => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/superadmin/companies/${company_id}/assign-devices`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ device_ids: [device_id] }) // ✅ fixed key and array
      });

      if (!res.ok) throw new Error('Assignment failed');
      const data = await res.json();
      alert(`✅ Assigned: ${data.assigned_devices.join(', ')}`);
      fetchUnassignedDevices();
    } catch (err) {
      console.error(err);
      alert('Failed to assign device');
    }
  };

  const handleUnassign = async (device_id) => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/superadmin/companies/${company_id}/unassign-devices`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ device_ids: [device_id] }) // ✅ fixed key and array
      });

      if (!res.ok) throw new Error('Unassignment failed');
      const data = await res.json();
      alert(`🚫 Unassigned: ${data.unassigned_devices?.join(', ') || device_id}`);
      fetchUnassignedDevices();
    } catch (err) {
      console.error(err);
      alert('Failed to unassign device');
    }
  };

  useEffect(() => {
    fetchUnassignedDevices();
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <h2>Assign Devices to Company ID: {company_id}</h2>

      {loading ? (
        <p>Loading devices...</p>
      ) : devices.length === 0 ? (
        <p>No unassigned devices available.</p>
      ) : (
        <table border="1" cellPadding="10" style={{ width: '100%', marginTop: 20 }}>
          <thead>
            <tr>
              <th>Device ID</th>
              <th>Device Name</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {devices.map((device) => (
              <tr key={device.device_id}>
                <td>{device.device_id}</td>
                <td>{device.device_name}</td>
                <td>{device.status}</td>
                <td>
                  <button onClick={() => handleAssign(device.device_id)}>Assign</button>
                  &nbsp;
                  {/* <button onClick={() => handleUnassign(device.device_id)}>Unassign</button> */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
